import { ArrowLeftOutlined } from '@ant-design/icons';
import { styled } from '@stitches/configed';
import { Button, Layout, Space } from 'antd';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useNavContext } from '../NavContext';

const Container = styled('div', {
  position: 'relative',
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  padding: '0 16px',
  background: '#fff',
  boxShadow: '0 1px 4px rgb(0 21 41 / 8%)',
});

const Heading = styled('div', {
  fontSize: 18,
  // lineHeight: 38,
  marginLeft: 16,
  color: '$text1',
  fontWeight: 600,
  '@xs': {
    fontSize: 24,
  },
});

const Right = styled('div', {
  // padding: 8,
  // marginTop: 8,
  marginLeft: 'auto',
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ButtonCollapse = styled('div', {
  cursor: 'pointer',
  border: '1px solid $border',
  borderRadius: 6,
  padding: '4px 8px',
  display: 'inline-block',
  transition: 'all 0.3s ease-in-out 0s',
  '@xs': {
    // top: 36,
  },

  div: {
    backgroundColor: '$brand',
    height: 3,
    borderRadius: 3,
    marginTop: 6,
    marginBottom: 6,
    marginLeft: 'auto',
    transition: 'all 0.3s ease-in-out',
    display: 'block',
  },
  'div:nth-child(1)': {
    width: 22,
  },
  'div:nth-child(2)': {
    width: 26,
  },
  'div:nth-child(3)': {
    width: 22,
  },

  '&:hover': {
    'div:nth-child(3), div:nth-child(1)': {
      width: 26,
    },
  },
});

type Props = {
  heading?: string;
  rightHeader?: ReactNode;
  toggleCollapsed?: () => void;
  goBack?: string;
};
export default function Header({
  heading,
  rightHeader,
  goBack,
}: Props) {
  const { showArrow, goBackExact } = useNavContext();
  return (
    <Layout.Header style={{ position: 'sticky', top: 0, zIndex: 999, height: 'auto' }}>
      <Container style={{ padding: '12px 16px' }}>

        {goBack && showArrow && (
          <Space style={{ padding: '20px 0' }}>
            <Link to={goBackExact ? goBackExact : goBack}>
              <Button
                type="text"
                style={{ boxShadow: 'none', border: '1px solid #D9DCE1' }}
              >
                <ArrowLeftOutlined style={{ fontSize: 20 }} />
              </Button>
            </Link>
          </Space>
        )}

        <Heading>{heading}</Heading>
        <Right>
          <Space>{rightHeader && rightHeader}</Space>
        </Right>
      </Container>
    </Layout.Header>
  );
}
